<template>
  <div class="pms-tabs-bar">
    <div class="pms-tabs">

      <router-link
        v-if="permission?.view_pms_cycles"
        :to="$url('/hr/performance/cycles')"
        class="pms-tab"
        :class="isActive(['PMS Cycles', 'PMS Cycle Detail']) ? 'pms-tab--active' : ''"
      >
        <font-awesome-icon icon="calendar-alt" class="tab-icon" />
        Appraisal Cycles
      </router-link>

      <router-link
        v-if="permission?.view_pms_goals"
        :to="$url('/hr/performance/goals')"
        class="pms-tab"
        :class="isActive(['PMS Goals']) ? 'pms-tab--active' : ''"
      >
        <font-awesome-icon icon="bullseye" class="tab-icon" />
        Goals
      </router-link>

      <router-link
        v-if="permission?.manage_pms_kpis"
        :to="$url('/hr/performance/kpi-library')"
        class="pms-tab"
        :class="isActive(['PMS KPI Library']) ? 'pms-tab--active' : ''"
      >
        <font-awesome-icon icon="chart-bar" class="tab-icon" />
        KPI Library
      </router-link>

      <router-link
        v-if="permission?.manage_pms_competencies"
        :to="$url('/hr/performance/competencies')"
        class="pms-tab"
        :class="isActive(['PMS Competencies']) ? 'pms-tab--active' : ''"
      >
        <font-awesome-icon icon="star" class="tab-icon" />
        Competencies
      </router-link>

      <router-link
        v-if="permission?.view_pms_reviews"
        :to="$url('/hr/performance/reviews')"
        class="pms-tab"
        :class="isActive(['PMS Reviews', 'PMS Review Form']) ? 'pms-tab--active' : ''"
      >
        <font-awesome-icon icon="clipboard-check" class="tab-icon" />
        Reviews
      </router-link>

      <router-link
        v-if="permission?.manage_pms_bonus"
        :to="$url('/hr/performance/bonus-engine')"
        class="pms-tab"
        :class="isActive(['PMS Bonus Engine']) ? 'pms-tab--active' : ''"
      >
        <font-awesome-icon icon="coins" class="tab-icon" />
        Bonus Engine
      </router-link>

      <router-link
        v-if="permission?.sync_pms_payroll"
        :to="$url('/hr/performance/payroll-sync')"
        class="pms-tab"
        :class="isActive(['PMS Payroll Sync']) ? 'pms-tab--active' : ''"
      >
        <font-awesome-icon icon="sync" class="tab-icon" />
        Payroll Sync
      </router-link>

      <router-link
        v-if="permission?.view_pms_reports"
        :to="$url('/hr/performance/reports')"
        class="pms-tab"
        :class="isActive(['PMS Reports']) ? 'pms-tab--active' : ''"
      >
        <font-awesome-icon icon="chart-pie" class="tab-icon" />
        Reports
      </router-link>

    </div>
  </div>
</template>

<script>
import { computed } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  setup() {
    const store      = useStore();
    const router     = useRouter();
    const permission = computed(() => store.state.getCurrentUserPermission);
    const isActive   = (names) => names.includes(router.currentRoute.value.name);
    return { permission, isActive };
  },
};
</script>

<style scoped>
.pms-tabs-bar {
  background: #fff;
  border-bottom: 1px solid #e4eaf2;
  padding: 0 20px;
  margin-bottom: 20px;
}
.pms-tabs {
  display: flex;
  align-items: center;
  gap: 2px;
  overflow-x: auto;
  scrollbar-width: none;
}
.pms-tabs::-webkit-scrollbar { display: none; }
.pms-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 13px 16px;
  font-size: 13.5px;
  font-weight: 500;
  color: #7a90b0;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
  margin-bottom: -1px;
  cursor: pointer;
}
.pms-tab:hover { color: #004AAD; text-decoration: none; }
.pms-tab--active {
  color: #004AAD !important;
  border-bottom-color: #004AAD !important;
  font-weight: 600;
}
.tab-icon { font-size: 13px; opacity: 0.85; }
@media (max-width: 576px) {
  .pms-tabs-bar { padding: 0 12px; }
  .pms-tab      { padding: 11px 12px; font-size: 13px; }
}
</style>
